Alpine.data('accordion', ($el, uniqueID) => ({
	expandedAccordions: [],

	id(index, suffix = '') {
		return `accordion-${uniqueID}-${index}${suffix}`;
	},
	toggle(index) {
		if (this.expanded(index)) {
			this.expandedAccordions = this.expandedAccordions.filter(
				(i) => i !== index
			);
		} else {
			this.expandedAccordions.push(index);
		}
	},
	expanded(index) {
		return this.expandedAccordions.includes(index);
	},
	isHover(target, isHovered) {
		$el
			.querySelector(`#${target}`)
			.classList.toggle('accordion__item--hover-within', isHovered);
	},
}));
